import Highcharts from 'highcharts';

export const figure11 = {
chart: {
zoomType: 'xy',
animation: false,
marginTop: 50,
marginLeft: 270,
plotBackgroundColor: null,
plotBorderWidth: null,
plotShadow: false,
type: 'bar',
height: '600px',
backgroundColor: 'rgba(255, 255, 255, 0.0)',
style: {
fontFamily: 'Montserrat'
}
},

colors: ['#ffc000', '#fff3cd','#ffd653'],

credits: {
enabled: false
},
title: {
text: null
},
subtitle: {
text: null
},

plotOptions: {
series: {
borderWidth: 0,
marker: {
symbol: 'circle',
enabled: false,
states: {
	    hover: {
			   enabled: true,
			   radius: 5
		   }
    }
}
}
},

exporting: {
enabled: false
},

xAxis: [{
reversed: true,
categories: [ "العالم", "", "أستراليا ونيوزيلندا", "أوقيانوسيا باستثناء أستراليا ونيوزيلندا", "أمريكا الشمالية وأوروبا الغربية", "أمريكا اللاتينية ومنطقة البحر الكاريبي", "غربي آسيا وشمال أفريقيا", "شرق آسيا وجنوب شرق آسيا", "آسيا الوسطى وجنوب آسيا", "أفريقيا جنوب الصحراء" ],
lineColor: "#d7d7d7",
tickColor: "#d7d7d7",
tickLength: 16,
labels: {
style: {
fontWeight: 'normal',
color: '#999999',
fontSize: '12px'
}
},
}],
yAxis: [{
labels: {
		format: '{value:.1f}',
style: {
	 fontWeight: 'normal',
	 color: '#999999',
	 fontSize: '12px'
 },
	},
	max: 200.0,
	min: 0,
	tickInterval: 50,
gridLineWidth: 2,
title: {
text: 'الأطفال المتضررون (بالملايين)',
style: {
       color: Highcharts.getOptions().colors[1]
}
}
}],
tooltip: {
shared: true,
useHTML: true,
hideDelay: 500,
backgroundColor: null,
borderWidth: 0,
shadow: false,
style: {
padding: 0
}
},
legend: {
enabled: false,
},

series: [      
{
name: '2000',
tooltip: {
valueSuffix: '%'
},
dataLabels: {
enabled: true,
formatter: function () {
	return Highcharts.numberFormat(this.y, 1);
},
style: {
	fontWeight: 'normal',
	textOutline: false,
	color: '#999999',
	fontSize: '10px'
}
},
data: [204.2, null, 0.0, 0.4, 3.1, 10.0, 11.5, 39.4, 91.3, 48.7],
},
{
name: '2012',
tooltip: {
valueSuffix: '%'
},
dataLabels: {
enabled: true,
style: {
	fontWeight: 'normal',
	textOutline: false,
	color: '#999999',
	fontSize: '10px'
}
},
data: [177.9, null, 0.1, 0.6, 2.6, 6.8, 11.5, 25.0, 76.4, 55.1],
},
{
name: '2022',
tooltip: {
valueSuffix: '%'
},
dataLabels: {
enabled: true,
style: {
	fontWeight: 'normal',
	textOutline: false,
	color: '#999999',
	fontSize: '10px'
}
},
data: [148.1, null, 0.1, 0.7, 2.1, 5.7, 10.2, 18.3, 54.3, 56.8],
},
]
}
